import HK_711 from "./711_HK"
import SG_711 from "./711_SG"
export default {
  18: HK_711,
  19: SG_711
}
